export interface ServiceResponse {
    message?: string,
    status: ServiceResponseStatus,
}

export enum ServiceResponseStatus {
    OK,
    FAILURE,
}